/**
 * mf-facet-search.js — buscador dentro de los filtros de lista largos.
 *
 * "Tipo de producto" tiene cien valores en Herramientas y se ven cinco a la
 * vez; "Marca" tendrá decenas en casi cualquier colección. Escribir tres
 * letras es más rápido que desplazarse por una lista alfabética.
 *
 * Lo pinta snippets/list-filter.liquid cuando un filtro tiene más de doce
 * valores. Todo va por delegación en document: los filtros se vuelven a
 * pintar por AJAX al cambiar y el script se evalúa una sola vez aunque la
 * etiqueta aparezca en varios filtros (es un módulo).
 *
 * - Filtra sin distinguir mayúsculas ni tildes ("fontaneria" encuentra
 *   "Fontanería").
 * - Mientras hay texto, enseña también los valores que "Mostrar más" oculta
 *   en móvil.
 * - Al marcar un valor se vacía la búsqueda: el filtro se vuelve a pintar y
 *   así la lista nunca queda a medio filtrar.
 * - Los eventos del buscador no llegan al formulario de filtros, que si no
 *   relanzaría la búsqueda de productos al salir del campo.
 */

const SELECTOR_CAMPO = '[data-mf-facet-search]';

/** @param {string | null | undefined} texto */
const normalizar = (texto) =>
  (texto || '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .trim();

/** @param {HTMLInputElement} campo */
function aplicar(campo) {
  const panel = campo.closest('[data-mf-facet-panel]');
  if (!panel) return;

  const consulta = normalizar(campo.value);
  let visibles = 0;

  panel.querySelectorAll('.facets__inputs-list-item').forEach((item) => {
    const coincide = !consulta || normalizar(item.textContent).includes(consulta);
    item.classList.toggle('mf-facet-oculto', !coincide);
    if (coincide) visibles += 1;
  });

  panel.classList.toggle('mf-facet-buscando', consulta.length > 0);

  const vacio = panel.querySelector('[data-mf-facet-vacio]');
  if (vacio instanceof HTMLElement) vacio.hidden = !(consulta && visibles === 0);
}

/** @param {EventTarget | null} objetivo */
const esCampo = (objetivo) => objetivo instanceof HTMLInputElement && objetivo.matches(SELECTOR_CAMPO);

// Escribir: filtrar la lista. En captura, para que no llegue a los
// componentes de filtros de Horizon.
document.addEventListener(
  'input',
  (event) => {
    if (!esCampo(event.target)) return;
    event.stopPropagation();
    aplicar(/** @type {HTMLInputElement} */ (event.target));
  },
  true
);

// Salir del campo dispara "change": tampoco debe llegar al formulario.
document.addEventListener(
  'change',
  (event) => {
    if (esCampo(event.target)) event.stopPropagation();
  },
  true
);

// Intro no envía el formulario.
document.addEventListener(
  'keydown',
  (event) => {
    if (event.key === 'Enter' && esCampo(event.target)) event.preventDefault();
  },
  true
);

// Al marcar un valor, vaciar la búsqueda de ese filtro.
document.addEventListener('change', (event) => {
  const objetivo = event.target;
  if (!(objetivo instanceof HTMLInputElement) || esCampo(objetivo)) return;
  const panel = objetivo.closest('[data-mf-facet-panel]');
  const campo = panel && panel.querySelector(SELECTOR_CAMPO);
  if (!(campo instanceof HTMLInputElement) || !campo.value) return;
  campo.value = '';
  aplicar(campo);
});
